import React from "react";
import { Card, CardBody } from "reactstrap";
import { MenuItem } from "../../../../../redux/menuSlice";
import OrderItemsTable from "./OrderItemsTable";

export interface CollectedItemsTableProps {
    setOrderItems: any;
    orderItems: any;
    unavailableItemIds?: Set<string>;
}

const CollectedItemsTable: React.FC<CollectedItemsTableProps> = ({
    orderItems,
    setOrderItems,
    unavailableItemIds = new Set()
}) => {
    const handleAddItem = (chooseItem: MenuItem) => {
        const updatedOrderItems = orderItems.map((item: MenuItem) => {
            const isMatch = item.id === chooseItem.id || (
                item.menuItemId !== undefined && chooseItem.menuItemId !== undefined && item.menuItemId === chooseItem.menuItemId
            );
            if (isMatch) {
                return { ...item, quantity: (item?.quantity ?? 0) + 1 };
            }
            return item;
        });
        setOrderItems(updatedOrderItems);
    };

    const handleRemoveItem = (chooseItem: MenuItem) => {
        const updatedOrderItems = orderItems
            .map((item: MenuItem) => {
                const isMatch = item.id === chooseItem.id || (
                    item.menuItemId !== undefined && chooseItem.menuItemId !== undefined && item.menuItemId === chooseItem.menuItemId
                );
                if (isMatch) {
                    return { ...item, quantity: (item.quantity ?? 0) - 1 };
                }
                return item;
            })
            .filter((item: MenuItem) => (item.quantity ?? 0) > 0);
        setOrderItems(updatedOrderItems);
    };

    const handleDiscountChange = (chooseItem: MenuItem, discount: number) => {
        const updatedOrderItems = orderItems.map((item: MenuItem) => {
            const isMatch = item.id === chooseItem.id || (
                item.menuItemId !== undefined && chooseItem.menuItemId !== undefined && item.menuItemId === chooseItem.menuItemId
            );
            if (isMatch) {
                return { ...item, perItemManualDiscount: discount };
            }
            return item;
        });
        setOrderItems(updatedOrderItems);
    };

    return (
        <>
            <Card>
                <CardBody>
                    <OrderItemsTable
                        orderItems={orderItems}
                        handleAddItem={handleAddItem}
                        handleRemoveItem={handleRemoveItem}
                        setOrderItems={setOrderItems}
                        handleDiscountChange={handleDiscountChange}
                        unavailableItemIds={unavailableItemIds}
                    />
                </CardBody>
            </Card>
        </>
    );
};

export default CollectedItemsTable;